import jwtAuthService from "../../services/jwtAuthService";
import { setPeriodDate, setUserData } from "./UserActions";
import history from "@history.js";

export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_LOADING = "LOGIN_LOADING";
export const RESET_PASSWORD = "RESET_PASSWORD";

export function loginWithEmailAndPassword({ email, password, isMobile }) {
  return (dispatch) => {
    dispatch({
      type: LOGIN_LOADING,
    });

    jwtAuthService
      .loginWithEmailAndPassword(email, password, isMobile)
      .then((user) => {
        dispatch(setUserData(user));

        // set default start date by first month
        dispatch(setPeriodDate(1));

        console.log("usersssssssss", user.role.roleLable);

        let url = window.location.href.includes("mobile") ? "/mobile/home" : "/dashboard";

        if (user.role.roleLable === 6) {
          url = "/support";
        }

        // console.log("url", url);

        if (!user.error) {
          history.push({
            pathname: url,
          });
        }

        return dispatch({
          type: LOGIN_SUCCESS,
        });
      })
      .catch((error) => {
        return dispatch({
          type: LOGIN_ERROR,
          payload: error,
        });
      });
  };
}

export function resetPassword({ email }) {
  return (dispatch) => {
    dispatch({
      payload: email,
      type: RESET_PASSWORD,
    });
  };
}
